import React ,{ useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card, Typography, Button, Avatar } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { useDispatch, useSelector } from "react-redux";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { ADMINISTRAR_LIQUIDACIONES_PERMISOS } from "../../../utils/permisos";
import { cleanComprobantesTomados, getComprobantesTomados, putLiberarComprobante } from "../../../actions/liquidaciones/liquidaciones";
const baseUrl = process.env.REACT_APP_URL;

const useStyles = makeStyles({
  card: {
    padding: 20,
    height: 480,
    width: 1050,
    marginTop: 40,
  },
  cardHeightOnlyUser: {
    height: 250,
  },
  tableTitle: {
    marginBottom: 15,
  },
  button: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

export const AdministrarLiquidaciones = ({type = 'allUsers'}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { comprobantesTomados, comprobantesTomadosUsuario } = useSelector((state) => state.liquidaciones);
    const { permisos: permisosUser, idUsuario} = useSelector((state) => state.auth);

    const items = type === 'allUsers' ? comprobantesTomados : comprobantesTomadosUsuario;

    useEffect(() => {
      if(type === 'allUsers'){
        dispatch( getComprobantesTomados() );
        dispatch( cleanComprobantesTomados() );
      }
    }, [dispatch]);

    const handleLiberarComprobante = id => {
        dispatch( putLiberarComprobante(id, type) );
    }

    const columns = [
        { 
            field: '', 
            headerName: '', 
            width: 60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <Avatar 
                    alt={params.getValue('usuarioTomado').userName} 
                    src={`${ baseUrl }/${ params.getValue('usuarioTomado').urlImagen }`} 
                />
            ),
        },
        { 
          field: 'userName', 
          headerName: 'Nombre Usuario', 
          width: 175,
          valueGetter: (params) =>
            `${params.getValue('usuarioTomado').userName || ''}`,
        },
        { 
          field: 'idComprobante', 
          headerName: 'Id Comprobante', 
          width: 160,
          renderCell: (params) => (
            params.getValue('idComprobante'))
        },
        // { 
        //   field: 'nroFactura', 
        //   headerName: 'N° Factura', 
        //   width: 125,
        //   valueGetter: (params) =>
        //     `${params.getValue('comprobante').nroSucursal || ''}-${params.getValue('comprobante').nroFactura || ''}`,
        // },
        { 
          field: 'efectorFacturacion', 
          headerName: 'Efector Facturación', 
          width: 200,
          valueGetter: (params) =>
            `${params.getValue('comprobante').comprobanteContrato?.efectorFacturacion?.razonSocial || ''}`,
        },
        { 
          field: 'cuit', 
          headerName: 'Cuit', 
          width: 130,
          valueGetter: (params) =>
            `${params.getValue('comprobante').comprobanteContrato?.efectorFacturacion?.cuit || ''}`,
        },
        { 
          field: 'fechaTomado', 
          headerName: 'Fecha Tomado', 
          width: 165,
          renderCell: (params) => (
            new Date(params.getValue('fechaTomado')).toLocaleString(
                "es",
                optionsfecha
            )
          ),
        },
        { 
            field: 'action', 
            headerName: 'Accion', 
            width: 110,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <strong>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {handleLiberarComprobante(params.getValue('id'))}}
                      disabled={!validarSoloUnPermiso(permisosUser, ADMINISTRAR_LIQUIDACIONES_PERMISOS.LIBERAR) && 
                                  type === 'allUsers' && params.getValue('usuarioTomado').idUsuario !== idUsuario}
                    >
                    Liberar
                    </Button>
                </strong>
            ),
        }
    ];
      
    return (
      <div>
        <Grid> 
            <Grid container justify="center">
                <Card className={`${classes.card} ${(type === 'currentUser' || items.length === 0) && classes.cardHeightOnlyUser}`} >
                    <Typography className={classes.tableTitle}>
                        <strong>Comprobantes Tomados</strong></Typography>
                    <div style={items.length === 0 ? { height: 180 } : { height: 400 }}>
                      <DataGrid  
                          rows={items} 
                          columns={columns}
                          disableSelectionOnClick={true}
                          pageSize={5}
                          localeText={{
                              noRowsLabel: 'Sin registros',

                              toolbarDensity: "Tamaño",
                              toolbarDensityLabel: "Tamaño",
                              toolbarDensityCompact: "Chico",
                              toolbarDensityStandard: "Mediano",
                              toolbarDensityComfortable: "Grande",
                              toolbarColumns: "Columnas",
                              toolbarColumnsLabel: "Seleccion de Columnas",
                              toolbarFilters: "Filtros",
                              toolbarFiltersLabel: "Mostrar Filtros",
                              toolbarFiltersTooltipHide: "Ocultar Filtros",
                              toolbarFiltersTooltipShow: "Mostrar Filtros",
                              toolbarFiltersTooltipActive: (count) => `${count} Filtros Activos`,
                              // Columns panel text
                              columnsPanelTextFieldLabel: "Buscar columna",
                              columnsPanelTextFieldPlaceholder: "Columnas",
                              columnsPanelDragIconLabel: "Reordenar Columnas",
                              columnsPanelShowAllButton: "Mostrar Todas",
                              columnsPanelHideAllButton: "Ocultar Todas",
                  
                              // Filter panel text
                              filterPanelAddFilter: "Agregar Filtros",
                              filterPanelDeleteIconLabel: "Eliminar",
                              filterPanelOperators: "Operador",
                              filterPanelOperatorAnd: "Y",
                              filterPanelOperatorOr: "O",
                              filterPanelColumns: "Columnas",
                  
                              // Filter operators text
                              filterOperatorContains: "Contiene",
                              filterOperatorEquals: "Igual",
                              filterOperatorStartsWith: "Empieza con",
                              filterOperatorEndsWith: "temrina con",
                              filterOperatorIs: "es",
                              filterOperatorNot: "no es",
                              filterOperatorOnOrAfter: "despues",
                              filterOperatorBefore: "antes",
                              filterOperatorOnOrBefore: "antes",
                  
                              // Column menu text
                              columnMenuLabel: "Menu",
                              columnMenuShowColumns: "Mostrar",
                              columnMenuFilter: "Filtros",
                              columnMenuHideColumn: "Ocultar",
                              columnMenuUnsort: "Deshacer",
                              columnMenuSortAsc: "Ordenar Asc",
                              columnMenuSortDesc: "Ordenar Desc",
                  
                              // Column header text
                              columnHeaderFiltersTooltipActive: (count) =>
                                  `${count} filtros activos`,
                              columnHeaderFiltersLabel: "Filtros",
                              columnHeaderSortIconLabel: "Ordenar",
                  
                              // Rows selected footer text
                              footerRowSelected: (count) =>
                                  count !== 1
                                  ? `${count.toLocaleString()} rows selected`
                                  : `${count.toLocaleString()} row selected`,
                  
                              // Total rows footer text
                              footerTotalRows: "Total Registros:",
                  
                              // Pagination footer text
                              footerPaginationRowsPerPage: "Registros por pagina:",
                              }}
                      />
                    </div>
                </Card>
            </Grid>
        </Grid>
      </div>
    );

};
